import GameInfoPlayers from './GameInfoPlayers';
import GameInfoSettings from './GameInfoSettings';

export type GameInfoProps = {
  game: Record<string, unknown>;
  applyGameUpdate?: (payload: Record<string, unknown>) => void;
};

export default function GameInfo({ game, applyGameUpdate }: GameInfoProps) {
  return (
    <div className="relative h-full w-full flex flex-col-reverse md:flex-row">
      <GameInfoSettings game={game} />
      <GameInfoPlayers game={game} applyGameUpdate={applyGameUpdate} />
    </div>
  );
}
